<template>
  <aside :class="'list-card-add__comprado' + (product_page ? '-product' : '')">
    <div class="list-card-add__comprado-add" v-if="!alreadyBought">
      <label for="comprado" @click.stop="showBuy = true">
        <input type="checkbox" :id="'comprado' + product.id" :key="product.id" />
        <span>{{ $t("generic.setAsPurchased") }}</span>
      </label>
    </div>
    <FluxRegaloWizard
      :visible="showBuy"
      :product="product"
      :list="myList"
      :retailer="product.retailerName"
      :initialStep="2"
      @close="showBuy = false"
    />
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import FluxRegaloWizard from "./FluxRegaloWizard.vue";

export default {
  name: "AlreadyBought",
  components: {
    FluxRegaloWizard,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    product_page: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      myList: "myList",
    }),
    list() {
      return this.myList;
    },
  },
  data() {
    return {
      alreadyBought: false,
      SoldByHelloBB: "No",
      showAlreadyBought: false,
      showAlreadyBoughtContent: false,
      showBuy: false,
    };
  },
};
</script>
